import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {DESIGN_BLOG_POST_FIELDS_LIST} from "../../constants/design-blog-post.constant";
import DesignInfoFilters from "../design-info/design-info-filters";
import {getAllDesignInfo, getSingleDesignInfo, updateSingleDesignInfo} from "../../services/design-info-data.service";
import {DESIGN_INFO_IDS, DESIGN_INFO_KEYS} from "../../constants/design-info.constant";
import {getDataFromLocalStorage, setDataInLocalStorage} from "../../../common/utils/local-storage-util";
import {getSingleDesignProduct} from "../../services/design-product-data.service";
import {getSingleDesignById, updateSingleDesign} from "../../../design/services/design-data-service";
import ProductBlogPostTitles from "../product-blog-post/product-blog-post-titles";
import ShowBlogPostStatus from "./show-blog-post-status";
import {
    addSingleBlogPost,
    getSingleBlogPost,
    updateSingleBlogPost
} from "../../../content/services/blog-post-data-service";
import {updateSingleDesignSync} from "../../services/design-sync-data-service";
import {getCurrentDesignSyncByType} from "../../utils/design-sync-util";
import {
    getSingleBlogPostContent,
    getSingleBlogPostContentByBlogPostId
} from "../../../content/services/blog-post-content-data-service";
import ProductBlogPostPreviewMode from "../product-blog-post/product-blog-post-preview-mode";
import ProductBlogPostAutomationConfig from "./product-blog-post-automation-config";
import DesignBlogPostEditMode from "./design-blog-post-edit-mode";
import ProductBlogPostStatistics from "../product-blog-post/product-blog-post-statistics";
import rehypeRaw from "rehype-raw";
import ReactMarkdown from "react-markdown";
import ProductBlogPostMeta from "../product-blog-post/product-blog-post-meta";
import AddEditImageMedia from "../../../marketing/components/media-editor/add-edit-image-media";
import {getSingleMedia, searchMediasWithSearchCriteria} from "../../../marketing/services/media-data.service";
import RenderMediaStage from "../../../marketing/components/media-editor/render-media-stage";
import {searchShopifyBlogs} from "../../services/shopify-blog-data-service";
import {prepareCreatedArticleDetail, prepareShopifyBlogArticle} from "../../utils/shopify-blog-util";
import {initPublishArticleToShopifyBlog} from "../../../common/services/cloud-function-service";
import {markAsPublishedBlogPost, markAsReadyBlogPost} from "../../../content/utils/blog-content-util";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";

const defaultFilterCriteria: any = {};

const DesignBlogPostsList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [allDesignInfo, setAllDesignInfo] = useState(null);
    const [designInfoList, setDesignInfoList] = useState(null);
    const [filteredDesignList, setFilteredDesignList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [selectedDesignInfo, setSelectedDesignInfo] = useState(null);
    const [selectedBlogPost, setSelectedBlogPost] = useState(null);
    const [selectedBlogPostContent, setSelectedBlogPostContent] = useState(null);
    const [selectedDesignDetail, setSelectedDesignDetail] = useState(null);
    const [designProduct, setDesignProduct] = useState(null);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [showDesignList, setShowDesignList] = useState(true);
    const [syncUpdateInProgress, setSyncUpdateInProgress] = useState(false);
    const [previewMode, setPreviewMode] = useState(true);
    const [actionConfig, setActionConfig] = useState({});
    const [featuredImageMedia, setFeaturedImageMedia] = useState(null);
    const [shopifyBlogsList, setShopifyBlogsList] = useState(null);
    const [imageBase64, setImageBase64] = React.useState(null);

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            getAllDesignsDesignInfo();
            getShopifyBlogList();
        }
    }, [initialStep]);

    const getAllDesignsDesignInfo = async () => {
        setDataFetchInProgress(true);
        const allDesignInfoList = await getAllDesignInfo();
        const allDesignsDesignInfo = _.find(allDesignInfoList, {id: DESIGN_INFO_IDS.ALL_DESIGNS});
        const tempDesignInfoList = _.filter(allDesignInfoList, (designInfo) => designInfo?.id !== DESIGN_INFO_IDS.ALL_DESIGNS);

        setAllDesignInfo(allDesignsDesignInfo);

        const allDesigns = _.orderBy(tempDesignInfoList, ['productType', 'category', 'name'], ['asc', 'asc', 'asc']);
        // const allDesigns = _.orderBy(tempDesignInfoList, ['updatedOn', 'productType', 'category', 'name'], ['asc', 'asc', 'asc', 'asc']);

        setDesignInfoList(allDesigns);
        setFilteredDesignList(allDesigns);
        setDataFetchInProgress(false);

        const existingFilters = getDataFromLocalStorage(DESIGN_INFO_KEYS.DESIGN_INFO_FILTERS);
        setFilterCriteria(existingFilters || defaultFilterCriteria);
    }

    useEffect(() => {
        if (!_.isEmpty(designInfoList)) {
            applyFilters(designInfoList);
            setDataInLocalStorage(DESIGN_INFO_KEYS.DESIGN_INFO_FILTERS, filterCriteria);
        }
    }, [filterCriteria]);

    const getShopifyBlogList = async () => {
        const blogListResult = await searchShopifyBlogs([]);
        setShopifyBlogsList(blogListResult);
    }

    const applyFilters = (designList) => {
        // let filteredList = [...designInfoList];
        let filteredList = designList;

        let existingFilterCriteria = {...filterCriteria};
        const filters = {};

        let blogPostStatus = '';
        _.forEach(existingFilterCriteria, (filterValue, filterKey) => {
            if (filterValue) {
                if (filterKey === 'blogPost.status') {
                    blogPostStatus = filterValue;
                } else {
                    if (filterValue === 'Yes') {
                        filters[filterKey] = true;
                    } else if (filterValue === 'No') {
                        filters[filterKey] = false;
                    } else {
                        filters[filterKey] = filterValue;
                    }
                }

            }
        });

        if (blogPostStatus) {
            filteredList = _.filter(filteredList, (designInfo) => {
                return designInfo?.blogPost?.status === blogPostStatus;
            });
        }

        filteredList = _.filter(filteredList, filters);
        setFilteredDesignList(filteredList);

        /*if (!selectedDesignInfo) {
            setSelectedDesignInfo(filteredList[0]);
        }*/
    }

    const getDesignProductForDesign = async (designInfo) => {
        const designProductDetail = await getSingleDesignProduct(designInfo?.id);
        setDesignProduct(designProductDetail);
    }

    const getFeaturedImageMedia = async (designInfo) => {
        let imageMedia;
        const designBlogPost = designInfo?.blogPost || {};

        if (designBlogPost && designBlogPost?.id) {
            const searchCriteriaList = [];
            searchCriteriaList.push({field: 'blogPostId', condition: '==', value: designBlogPost?.id});

            const imageMediaList = await searchMediasWithSearchCriteria(searchCriteriaList);

            if (imageMediaList?.length > 0) {
                imageMedia = imageMediaList[0];
            }
        }

        setFeaturedImageMedia(imageMedia);
    }

    const getDesignBlogPost = async (designInfo) => {
        const designBlogPost = designInfo?.blogPost || {};

        if (designBlogPost?.id) {
            const blogPost = await getSingleBlogPost(designBlogPost?.id);
            const productBlogs = _.filter(shopifyBlogsList, (blog) => blog.type === 'Product Blog');

            if (_.isEmpty(blogPost.shopifyBlogId) && !_.isEmpty(productBlogs)) {
                blogPost.shopifyBlogId = productBlogs[0].id;
            }

            setSelectedBlogPost(blogPost);

            if (blogPost?.title !== '' && blogPost?.title !== designBlogPost?.title) {
                designBlogPost.title = blogPost.title;
                designBlogPost.status = blogPost.status || 'New';
                designInfo.blogPost = designBlogPost;

                if (designBlogPost.status === "Published") {
                    designInfo.blogPostPublished = true;
                }

                await updateSingleDesignInfo(designInfo);

                const existingDesignInfoList = [...designInfoList];
                const designInfoIndex = _.findIndex(existingDesignInfoList, {id: designInfo.id});
                setSelectedDesignInfo(designInfo);

                existingDesignInfoList[designInfoIndex] = designInfo;
                setDesignInfoList(existingDesignInfoList);
            }

            await getDesignBlogPostContent(blogPost);
        } else {
            setSelectedBlogPost(null);
            setSelectedBlogPostContent(null);
        }
    }

    const getDesignBlogPostContent = async (blogPost) => {
        let existingBlogPostContent;

        if (blogPost?.id) {
            const blogPostContentList = await getSingleBlogPostContentByBlogPostId(blogPost?.id);
            existingBlogPostContent = blogPostContentList[0] || {};
        }

        setSelectedBlogPostContent(existingBlogPostContent);
    }

    const getDesignDetail = async (designInfo) => {
        const designDetailResult = await getSingleDesignById(designInfo?.id);
        setSelectedDesignDetail(designDetailResult);

        if (designDetailResult?.blogPost?.title === '' && !_.isEmpty(designInfo?.blogPost?.title)) {
            designDetailResult.blogPost.title = designInfo.blogPost.title;
            designDetailResult.blogPost.status = designInfo.blogPost.status;
            setSelectedDesignDetail(designDetailResult);

            await updateSingleDesign(designDetailResult);
        }
    }

    const handleBlogPostTitleSelection = async (designDetail, selectedTitle) => {
        const designBlogPost = designDetail?.blogPost || {};

        if (designBlogPost?.id) {
            const currentBlogPost = {...selectedBlogPost};

            if (currentBlogPost?.title === '') {
                currentBlogPost.title = selectedTitle;
                await updateSingleBlogPost(currentBlogPost);
                setSelectedBlogPost(currentBlogPost);
            }

            designBlogPost.title = currentBlogPost.title;
            designBlogPost.status = currentBlogPost.status || 'New';
        } else {
            const newBlogPost: any = {
                title: selectedTitle,
                type: 'Product Blog',
                status: 'New',
                designId: designDetail.id,
            }

            const newBlogPostResult = await addSingleBlogPost(newBlogPost);
            newBlogPost.id = newBlogPostResult.id;

            designBlogPost.id = newBlogPost.id;
            designBlogPost.title = newBlogPost.title;
            designBlogPost.status = newBlogPost.status;
            setSelectedBlogPost(newBlogPost);
        }

        designDetail.blogPost = designBlogPost;

        const existingDesignInfoList = [...designInfoList];
        const designInfoIndex = _.findIndex(existingDesignInfoList, {id: designDetail.id});
        const existingDesignInfo = existingDesignInfoList[designInfoIndex];
        existingDesignInfo.blogPost = designBlogPost;
        setSelectedDesignInfo(existingDesignInfo);

        existingDesignInfoList[designInfoIndex] = existingDesignInfo;
        setDesignInfoList(existingDesignInfoList);

        await updateSingleDesignInfo(existingDesignInfo);
        await updateSingleDesign(designDetail);

        applyFilters(existingDesignInfoList);
    }

    useEffect(() => {
        if (selectedDesignInfo) {
            handleDesignInfoSelection(selectedDesignInfo);
        }
    }, [selectedDesignInfo]);

    const handleDesignInfoSelection = async (designInfo) => {
        setDataFetchInProgress(true);

        await getDesignBlogPost(designInfo);
        await getDesignDetail(designInfo);
        await getDesignProductForDesign(designInfo);
        await getFeaturedImageMedia(designInfo);

        if (designInfo?.blogPost?.actionConfig) {
            setActionConfig(designInfo?.blogPost?.actionConfig);
        } else {
            // setActionConfig({});
        }

        setDataFetchInProgress(false);
    }


    const startBlogPostContentGeneration = async () => {
        setSyncUpdateInProgress(true);

        const currentActionConfig = {...actionConfig};
        const currentDesignInfo = {...selectedDesignInfo};

        const currentDesignSync = await getCurrentDesignSyncByType('BLOG_POST_CONTENT_GENERATION');
        currentDesignSync.designIds = currentDesignSync.designIds || [];

        if (!currentDesignSync.designIds.includes(currentDesignInfo.id)) {
            currentDesignSync.designIds.push(currentDesignInfo.id);
        }

        currentDesignSync.total = currentDesignSync.designIds.length;

        currentDesignSync.actionConfig = currentDesignSync.actionConfig || {};
        currentDesignSync.actionConfig[currentDesignInfo.id] = currentActionConfig;

        currentDesignSync.status = 'STARTED';

        await updateSingleDesignSync(currentDesignSync);

        currentDesignInfo.blogPost.actionConfig = currentActionConfig;
        await updateSingleDesignInfo(currentDesignInfo);

        const existingDesignInfoList = [...designInfoList];
        const designInfoIndex = _.findIndex(existingDesignInfoList, {id: currentDesignInfo.id});
        existingDesignInfoList[designInfoIndex] = currentDesignInfo;
        setDesignInfoList(existingDesignInfoList);

        setSyncUpdateInProgress(false);
    }

    const updateImageMediaInBlogPost = async (imageMedia) => {
        const currentBlogPost = {...selectedBlogPost};
        currentBlogPost.mediaId = imageMedia.id;
        await updateSingleBlogPost(currentBlogPost);
        setSelectedBlogPost(currentBlogPost);
        setFeaturedImageMedia(imageMedia);
    }

    const handleMarkAsPublishedBlogPost = async () => {
        setDataFetchInProgress(true);

        const existingBlogPost = {...selectedBlogPost};
        const existingBlogPostContent = {...selectedBlogPostContent};
        const article = prepareShopifyBlogArticle(existingBlogPost, existingBlogPostContent, imageBase64);
        const response = await initPublishArticleToShopifyBlog(article);

        const createdOrUpdatedArticle = response?.article;

        existingBlogPost.shopifyArticle = prepareCreatedArticleDetail(createdOrUpdatedArticle);
        await handleBlogPostAsPublished('Published', existingBlogPost);

        setDataFetchInProgress(false);
    }

    const handleBlogPostAsPublished = async (status = 'Published', currentBlogPost?) => {
        setDataFetchInProgress(true);
        const existingBlogPost = currentBlogPost || {...selectedBlogPost};

        if (status === 'Ready') {
            await markAsReadyBlogPost(existingBlogPost);
        } else {
            await markAsPublishedBlogPost(existingBlogPost);
        }

        setSelectedBlogPost(existingBlogPost);

        const updatedDesignInfo = await getSingleDesignInfo(existingBlogPost?.designId);
        updatedDesignInfo.blogPost.status = status || 'Published';
        await updateSingleDesignInfo(updatedDesignInfo);

        const existingDesignInfoList = [...designInfoList];
        const designInfoIndex = _.findIndex(existingDesignInfoList, {id: updatedDesignInfo.id});
        existingDesignInfoList[designInfoIndex] = updatedDesignInfo;
        setDesignInfoList(existingDesignInfoList);
        applyFilters(existingDesignInfoList);

        setSelectedDesignInfo(updatedDesignInfo);
        setDataFetchInProgress(false);
    }

    const handleUpdateBlogPost = async (existingBlogPost) => {
        const designInfo = await getSingleDesignInfo(existingBlogPost?.designId);
        designInfo.blogPost.status = existingBlogPost?.status || 'Published';
        await updateSingleDesignInfo(designInfo);

        return designInfo;
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center -ml-2 w-full">
                    <div className={'text-xl ml-2 w-48'}>
                        Design Blog Post
                    </div>

                    {designInfoList?.length > 0 &&
                        <div
                            className={'w-full flex justify-start items-start'}>
                            <DesignInfoFilters
                                dataFetchInProgress={false}
                                designs={designInfoList}
                                allDesignInfo={allDesignInfo}
                                showSecondaryFilters={false}
                                containerClass={''}
                                fieldClass={'w-fit'}
                                filterCriteria={filterCriteria}
                                setFilterCriteria={setFilterCriteria}/>
                        </div>
                    }

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress || syncUpdateInProgress}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start mt-4">

                <div className="w-1/4">

                    <div
                        className={'table-container-with-title-2 bg-white overflow-y-scroll border border-gray-400 rounded-lg'}>

                        <ShowEmptyListMessage
                            dataList={filteredDesignList}
                            dataFetchInProgress={false}
                            label={'Design Info'}/>

                        {filteredDesignList?.length > 0 && showDesignList &&
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 w-8">S.No</th>
                                    <th colSpan={2}
                                        className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 text-left">Name
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="">
                                {filteredDesignList?.map((designInfo, rowIndex) => (
                                    <tr key={`row-${rowIndex}`}
                                        onClick={() => {
                                            setSelectedDesignInfo(designInfo);
                                        }}
                                        className={`border-b border-gray-400 cursor-pointer hover:bg-green-100 ${selectedDesignInfo?.id === designInfo?.id ? 'bg-green-200' : ''}`}>
                                        <td className="p-2 m-auto">
                                            <div className="flex justify-center w-8">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        <td className={`p-2 m-auto flex justify-start items-center`}>
                                            <div className={'w-full'}>
                                                <span className={'mr-2'}>{designInfo?.name}</span>

                                                <div className={'w-20 mt-1'}>
                                                    <ShowBlogPostStatus blogPost={designInfo?.blogPost}/>
                                                </div>
                                            </div>
                                        </td>

                                        <td className="p-2 m-auto w-8">
                                            <div className="flex justify-center pr-2">
                                                <CopyDataToClipboard value={designInfo?.name}/>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        }

                    </div>

                </div>

                <div className={'w-3/4'}>

                    <div className={'flex w-full justify-between items-center'}>
                        <div className={'ml-4 mb-2 w-3/4'}>
                            {selectedDesignInfo?.blogPost?.title &&
                                <>
                                    <div className={'flex justify-start items-center'}>
                                        <div className={'mr-2'}>
                                            <CopyDataToClipboard value={selectedDesignInfo?.blogPost?.title}/>
                                        </div>
                                        <div className={'mr-2 font-semibold text-xl'}>
                                            {selectedDesignInfo?.blogPost?.title}
                                        </div>
                                    </div>

                                    <div className={'flex justify-between items-center'}>
                                        <div className={'flex justify-between items-center'}>
                                            <ShowBlogPostStatus blogPost={selectedDesignInfo?.blogPost}/>

                                            {selectedBlogPost?.shopifyBlogId &&
                                                <div className={'flex ml-4'}>
                                                    <button
                                                        className="button-sky-outline w-40 text-sm px-3 py-1 m-1"
                                                        onClick={() => handleBlogPostAsPublished()}>
                                                        Mark As Published
                                                    </button>

                                                    <button
                                                        className="button-sky-outline w-40 text-sm px-3 py-1 m-1"
                                                        onClick={() => handleBlogPostAsPublished('Ready')}>
                                                        Mark As Ready
                                                    </button>
                                                </div>
                                            }
                                        </div>

                                        <div className={'flex justify-center items-center'}>
                                            <button
                                                className={`${previewMode ? 'border-gray-600 text-gray-600 bg-gray-100' : 'border-green-600 text-green-100 bg-green-600 border'} border-l border-y rounded-l px-2 py-1 text-sm`}
                                                type="button"
                                                onClick={() => setPreviewMode(false)}>
                                                Edit Mode
                                            </button>
                                            <button
                                                className={`${previewMode ? 'border-green-600 text-green-100 bg-green-600 border' : 'border-gray-600 text-gray-600 bg-gray-100'} border-r border-y rounded-r px-2 py-1 text-sm`}
                                                type="button"
                                                onClick={() => setPreviewMode(true)}>
                                                Preview Mode
                                            </button>
                                        </div>

                                        <div className={'ml-2'}>
                                            <AddEditImageMedia
                                                isAddImageMedia={featuredImageMedia ? false : true}
                                                isEditImageMedia={featuredImageMedia ? true : false}
                                                selectedImageMedia={featuredImageMedia}
                                                isBlogPost={true}
                                                mediaFor={selectedBlogPost}
                                                designInfo={selectedDesignInfo}
                                                cssClass={'button-green-outline text-sm px-2 py-1 flex items-center justify-center'}
                                                afterSaveAction={updateImageMediaInBlogPost}/>
                                        </div>
                                    </div>
                                </>
                            }

                            {!selectedDesignInfo?.blogPost?.title &&
                                <h2 className={'text-gray-400'}>Title</h2>
                            }
                        </div>

                        <div className={'mr-2 w-1/4 text-right'}>
                            {featuredImageMedia && selectedBlogPost?.shopifyBlogId &&
                                <div>
                                    <button
                                        className="button-purple px-3 py-1 m-1"
                                        onClick={() => handleMarkAsPublishedBlogPost()}>
                                        Publish Blog Post
                                    </button>
                                </div>
                            }
                        </div>
                    </div>

                    <div className={'w-full pl-4 pr-2 mt-2 flex justify-between items-start'}>

                        <div
                            className={`flex w-3/4 border border-gray-400 ${previewMode ? 'bg-white' : 'bg-gray-400'} overflow-y-scroll px-4 pt-3 pb-16 rounded-lg`}>

                            {previewMode && !_.isEmpty(selectedBlogPostContent?.contentLines) &&
                                <div>

                                    <ShowEmptyListMessage
                                        dataList={[selectedDesignInfo]}
                                        dataFetchInProgress={false}
                                        label={'Design Info'}/>

                                    {featuredImageMedia &&
                                        <RenderMediaStage
                                            dimensionsMap={{}}
                                            isViewOnly={true}
                                            setImageBase64={setImageBase64}
                                            handleAttributeChanges={() => {
                                            }}
                                            selectedImage={undefined}
                                            setSelectedImage={() => {
                                            }}
                                            imageMedia={featuredImageMedia}
                                            layers={featuredImageMedia?.layers}
                                            setSettings={() => {
                                            }}
                                            settings={featuredImageMedia?.settings}/>
                                    }

                                    <div className={'my-6'}>
                                        <ProductBlogPostMeta
                                            blogPostContent={selectedBlogPostContent}/>
                                    </div>

                                    <ReactMarkdown
                                        children={selectedBlogPostContent?.htmlContent}
                                        rehypePlugins={[rehypeRaw]}
                                        skipHtml={false}
                                        className="mt-2 content-container pb-4 px-2"/>
                                </div>
                            }

                            {!previewMode && !_.isEmpty(selectedBlogPostContent?.contentLines) &&
                                <DesignBlogPostEditMode
                                    blogPostContent={selectedBlogPostContent}
                                    setBlogPostContent={setSelectedBlogPostContent}
                                    productsList={undefined}
                                    saveInProgress={dataFetchInProgress}
                                    setSaveInProgress={setDataFetchInProgress}/>
                            }

                            {selectedDesignDetail && selectedDesignDetail?.blogPost && selectedDesignDetail?.blogPost?.titlesList?.length > 0 &&
                                !selectedDesignInfo?.blogPost?.title &&
                                <ProductBlogPostTitles
                                    titles={selectedDesignDetail?.blogPost?.titlesList}
                                    showTitles={true}
                                    handleTitleSelection={(event) => {
                                        handleBlogPostTitleSelection(selectedDesignDetail, event);
                                    }}/>
                            }

                        </div>

                        <div className="w-1/4 pl-4">

                            <div
                                className={''}>

                                <div className="mb-4">
                                    <ProductBlogPostAutomationConfig
                                        startBlogPostContentGeneration={startBlogPostContentGeneration}
                                        actionConfig={actionConfig}
                                        setActionConfig={setActionConfig}/>
                                </div>

                                {/*<ProductBlogPostMeta
                                    blogPostContent={selectedBlogPostContent}/>*/}

                                <div className="mb-4">
                                    <ProductBlogPostStatistics statistics={selectedBlogPostContent?.statistics}/>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default DesignBlogPostsList
